 module Bookhus {
    export class HousegalleryDataService implements IHousegalleryDataService
    {
        private loadedHouses: { [key: number]: IHousegalleryEntry } = [];

        loadDataAjax(pagenumber: number, hideExternal: boolean): JQueryXHR {
            var self = this;

            if (self.loadedHouses[pagenumber]) {
                self.house = self.loadedHouses[pagenumber];
                return null;
            }

            var xhr = $.getJSON('/api/Housegallery?pageNumber=' + pagenumber + '&hideExternal=' + hideExternal, function (house) {
                self.loadedHouses[pagenumber] = house;
                self.house = house;
            });

            return xhr; 
        }

        house: IHousegalleryEntry;


        private generatedSequence: number[] = []
        private currentIndex: number = 0;

        generatePagenumberSequence(currentPagenumber: number, ownPropertyCount: number, totalPropertyCount: number, hideExternal: boolean) {
            this.generatedSequence = this.generatedSequence.concat(this.range(currentPagenumber, ownPropertyCount));
            this.generatedSequence = this.generatedSequence.concat(this.range(1, currentPagenumber - 1));
            this.generatedSequence = this.generatedSequence.concat(this.range(ownPropertyCount + 1, hideExternal ? ownPropertyCount : totalPropertyCount));
        }

        getPreviousPagenumber(): number {
            if (!this.generatedSequence || this.generatedSequence.length == 0) {
                return 1;
            }

            this.currentIndex = this.currentIndex == 0
                ? this.generatedSequence.length - 1
                : this.currentIndex - 1;
            return this.generatedSequence[this.currentIndex];
        }

        getNextPagenumber(): number {
            if (!this.generatedSequence || this.generatedSequence.length == 0) {
                 return 1;
            }

            this.currentIndex = this.currentIndex == this.generatedSequence.length - 1
                ? 0
                : this.currentIndex + 1;
            return this.generatedSequence[this.currentIndex];
         }

        private range(start, end): number[] {
            var result = [];
            for (var i = start; i <= end; i++) {
                result.push(i);
            }
            return result;
        }
    }
}